import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'storiesFilter', namespaced: true })
export default class StoriesFilter extends FilterModule {
    constructor(module: StoriesFilter) {
        super(module);
    }
}
